import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _loading$ = new ReplaySubject<boolean>(1);
  readonly loading$ = this._loading$.asObservable();

  setLoadingStatus(inProgress: boolean) {
    this._loading$.next(inProgress);
  }
}
